import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5187ec99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "connect_address" }
const _hoisted_2 = { class: "connect_address__info" }
const _hoisted_3 = { class: "connect_address__summary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Your email:", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "connect_address__warning box-shadow"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " During this activity your wallet address has been changed. Are you aware of it? ", -1 /* HOISTED */))
const _hoisted_7 = { class: "connect_address__warning box-shadow" }
const _hoisted_8 = {
  key: 0,
  class: "text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_10 = {
  key: 1,
  class: "text"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_12 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock($setup["Dialog"], {
    visible: $setup.show,
    "onUpdate:visible": [
      _cache[2] || (_cache[2] = ($event: any) => (($setup.show) = $event)),
      _cache[3] || (_cache[3] = ($event: any) => ($setup.emit('close')))
    ],
    modal: "",
    header: 'Providing '+$setup.addressType().toLocaleLowerCase()+ ' address',
    baseZIndex: -100,
    style: { width: '95vw', 'max-width': '800px' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, " You are going to link the email with the " + _toDisplayString($setup.getAddressType()) + " wallet address. ", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, _toDisplayString($setup.usersEmail), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString($setup.addressType()) + " address:", 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString($props.address), 1 /* TEXT */)
        ]),
        ($setup.warning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Icon, {
                style: {"height":"110px","width":"110px","color":"red"},
                name: "AlertTriangle"
              }),
              _hoisted_6,
              _createElementVNode("div", {
                class: "closeWarning",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.usePublicSalesStore().toggleWarning(false)))
              }, [
                _createVNode($setup["X"])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Icon, {
            style: {"height":"110px","width":"110px","color":"red"},
            name: "AlertTriangle"
          }),
          ($setup.props.addressType==$setup.AddressType.KEPLR)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(" Verify if the claimer address is one you expect to be the address you will use to claim your tokens."),
                _hoisted_9,
                _createTextVNode(" If this not expected address change to proper account in your wallet application. ")
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.props.addressType==$setup.AddressType.METAMASK)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(" Verify if the EVM source address is one you expect to be the address from which you will send your USDT/USDC."),
                _hoisted_11,
                _createTextVNode(" If this not expected address change to proper account in your wallet application. ")
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Button, {
          class: "p-button p-component secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('confirm')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Confirm")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "header"]))
}